"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(activity) {
  return activity && activity.from.role === 'bot';
};

exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJhY3Rpdml0eSIsImZyb20iLCJyb2xlIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2RlZmluaXRpb25zL2FjdGl2aXR5RnJvbUJvdC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBhY3Rpdml0eSA9PiBhY3Rpdml0eSAmJiBhY3Rpdml0eS5mcm9tLnJvbGUgPT09ICdib3QnO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O2VBQWUsa0JBQUFBLFFBQVE7RUFBQSxPQUFJQSxRQUFRLElBQUlBLFFBQVEsQ0FBQ0MsSUFBVCxDQUFjQyxJQUFkLEtBQXVCLEtBQXZDO0FBQUEsQyJ9